export default "__VITE_PUBLIC_ASSET__d48de4db__"